import React from 'react';
// import { BarChart } from 'react-feather';
import { NavLink } from 'react-router-dom';
// import ColoredLogo from '../../assets/colored_logo.png'
// import ColoredCloudLogo from '../../assets/colored_cloud_logo.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle, faChevronDown, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
// import ToggleIcon from "../../assets/ham_btn.png";
// import { Navbar, NavbarToggler, Collapse, Nav, NavItem, NavLink, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { useAuth0 } from "../../react-auth0-spa"

// import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
// import setToggleSidebar from '../../store/actions/navbarActions'
import CommonConfig from '../commonConfig.json';

import "./NavBar.css";
import { Menu } from 'antd';
const { SubMenu } = Menu;
let envs = CommonConfig.envs;

const NavBar = (props) => {
  // const [isOpen, setOpen] = useState(true);
  // const toggle = () => setOpen(!isOpen);
  // const toggle = () => !props.isOpen;

  const { isAuthenticated, logout } = useAuth0();
  let hmg = process.env["REACT_APP_HMG"];
  let REACT_APP_SSO_URL = process.env["REACT_APP_SSO_URL"];
  let REACT_APP_COMPANY_LOGO = process.env["REACT_APP_COMPANY_LOGO"];
  let REACT_APP_COMPANY_NAME = process.env["REACT_APP_COMPANY_NAME"];
  let REACT_APP_COMPANY_LOGO_SMALL = process.env["REACT_APP_FAVICON"];
  //let history = useHistory();
  return (
    <Menu mode="horizontal">
      {/* <Menu.Item key="toogle" onClick={props.setToggleSidebar}>
        <img src={ToggleIcon} />
      </Menu.Item>
      <span class="appName">QMS</span> */}
      <Menu.Item className="navMainLogo">
        <a href={REACT_APP_SSO_URL}>
          <img className="mainLogo" src={REACT_APP_COMPANY_LOGO} alt={REACT_APP_COMPANY_NAME+" Logo"} />
          <img className="mainSmallLogo" src={REACT_APP_COMPANY_LOGO_SMALL} alt={REACT_APP_COMPANY_NAME+" Logo"} />
        </a>
      </Menu.Item>
      <Menu.Item className="navAppSec">
        <span className="navAppNameLine"></span>
        <span className="navAppName">
          {
            props.appToLoad == null || props.appToLoad == undefined ?
            '':
            (props.appToLoad == CommonConfig.apps.COMPLIANCE ?
              'Compliance':
              props.appToLoad
            )
          }
        </span>
      </Menu.Item>
      {!props.loading && (props.user) ? (
          
          (hmg !== envs.MARRIOTT)?(
              <SubMenu
              className="navUserProfileDrpDwn"
                popupClassName="navUserProfileDrpDwnPopup"
                style={{float: 'right'}}
                title={
                  <span className="submenu-title-wrapper">
                    {/* <img
                      className="userProfileIcon"
                      src={props.user.picture}
                      alt={props.user.name}
                      width="40"
                    /> */}
                    <FontAwesomeIcon icon={faUserCircle}  className="navUserProfileIcon"/>
                    <span className="navUserProfileName">{props.user.name}</span>
                    <FontAwesomeIcon icon={faChevronDown}  className="navUserProfileArrowDwn"/>
                  </span>
                }
              >
                {isAuthenticated && (<Menu.Item className="userProfileDropdownMenuLogout" key="auth0logout"><NavLink to="/logoutall" className="userProfileDropdownMenuItemLink" ><FontAwesomeIcon icon={faSignOutAlt} className="navUserProfileLogoutIcon" /> Logout</NavLink></Menu.Item>)}
              </SubMenu>
            ):(
              <Menu.Item
                className="navUserProfileDrpDwn"
                style={{float: 'right'}}
              >
                <FontAwesomeIcon icon={faUserCircle}  className="navUserProfileIcon"/>
                <span className="navUserProfileName">{props.user.name}</span>
              </Menu.Item>
              // <span className="submenu-title-wrapper floatSubMenu">
              //   <img
              //     className="userProfileIcon"
              //     src={props.user.picture}
              //     alt={props.user.name}
              //     width="40"
              //   />
              //   {props.user.name}
              // </span>
            )
        ) : (
          <Menu.Item key="auth0login">
            <NavLink to="/api/login" className="userProfileDropdownMenuItemLink" >Login</NavLink>
          </Menu.Item>
        )
      }
    </Menu>
  );
}

function mapStateToProps(state){
  return {
  }
}

function matchDispatchToProps(dispatch){
  return {
  }
  // bindActionCreators({ 
  //   setToggleSidebar : setToggleSidebar
  //  }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(NavBar);